
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-custom-date-range-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule
],
  templateUrl: './custom-date-range-dialog.component.html',
  styleUrls: ['./custom-date-range-dialog.component.scss'],
})
export class CustomDateRangeDialogComponent {
  dialogRef = inject<MatDialogRef<CustomDateRangeDialogComponent>>(MatDialogRef);
  data = inject<{
    startDate: Date | null;
    endDate: Date | null;
}>(MAT_DIALOG_DATA);

  startDate: Date | null;
  endDate: Date | null;

  constructor() {
    const data = this.data;

    this.startDate = data.startDate;
    this.endDate = data.endDate;
  }

  getFormattedDate(date: Date | null): string {
    if (!date) {
      return 'Select date';
    }

    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close({
      startDate: this.startDate,
      endDate: this.endDate,
    });
  }
}

